"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingContainer = exports.Inner = exports.ButtonStyled = exports.buttonStyle = exports.IconWrapper = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledComponentsRtl = _interopRequireDefault(require("styled-components-rtl"));
var _mediaGenerator = _interopRequireDefault(require("@berlitz/max-utils/lib/mediaGenerator"));
var _polished = require("polished");
var _templateObject;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var loadingTransition = function loadingTransition(_ref) {
  var duration = _ref.duration,
    cubicBezier = _ref.cubicBezier;
  return (0, _styledComponents.css)(["all ", "ms ", ""], duration.fast, cubicBezier.default);
};
var loadingTransitionDelayed = function loadingTransitionDelayed(_ref2) {
  var duration = _ref2.duration,
    cubicBezier = _ref2.cubicBezier;
  return (0, _styledComponents.css)(["all ", "ms ", "ms ", ""], duration.fast, duration.fast, cubicBezier.default);
};
var IconWrapper = _styledComponents.default.span.withConfig({
  displayName: "Buttonstyle__IconWrapper",
  componentId: "di3ge1-0"
})(["display:inline-block;position:relative;", " transition:", ";"], (0, _styledComponentsRtl.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-left: ", ";\n  "])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.xxs;
}), function (_ref4) {
  var theme = _ref4.theme;
  return theme.animation.transitionFast;
});
exports.IconWrapper = IconWrapper;
var buttonStyle = function buttonStyle() {
  return (0, _styledComponents.css)(["", " ", " ", " ", ";"], function (_ref5) {
    var loading = _ref5.loading,
      canLoad = _ref5.canLoad,
      disabled = _ref5.disabled,
      small = _ref5.small,
      inlineBlock = _ref5.inlineBlock,
      _ref5$buttonType = _ref5.buttonType,
      buttonType = _ref5$buttonType === void 0 ? 'default' : _ref5$buttonType,
      _ref5$theme = _ref5.theme,
      button = _ref5$theme.button,
      animation = _ref5$theme.animation;
    return (0, _styledComponents.css)(["background-color:", ";border-radius:", ";color:", ";cursor:", ";display:", ";font-size:", ";font-weight:", ";line-height:", ";min-width:", ";padding:", ";pointer-events:", ";position:relative;text-decoration:none;transition:all ", ";width:auto;text-align:center;background-position:center;-webkit-transition:background 0.8s;-moz-transition:background 0.8s;-ms-transition:background 0.8s;-o-transition:background 0.8s;transition:background 0.8s;&:focus{background-color:", ";}&:hover{background:", " -webkit-radial-gradient( circle,transparent 1%,", " 1% ) center/15000%;background:", " -moz-radial-gradient( circle,transparent 1%,", " 1% ) center/15000%;background:", " -ms-radial-gradient( circle,transparent 1%,", " 1% ) center/15000%;background:", " -o-radial-gradient( circle,transparent 1%,", " 1% ) center/15000%;background:", " radial-gradient( circle,transparent 1%,", " 1% ) center/15000%;}&:active{background-color:", ";background-size:100%;-webkit-transition:background 0s;-moz-transition:background 0s;-ms-transition:background 0s;-o-transition:background 0s;transition:background 0s;}", " ", ""], button["".concat(buttonType, "BackgroundColor")], button.borderRadius, button["".concat(buttonType, "TextColor")], loading ? 'none' : 'pointer', inlineBlock ? 'inline-block' : 'inline', button.fontSize, button.fontWeight, button.lineHeightSm, canLoad ? '118px' : 'auto', button.padding, loading ? 'none' : 'auto', animation.transitionMedium, button["".concat(buttonType, "BackgroundColorHover")], button["".concat(buttonType, "BackgroundColorHover")], button["".concat(buttonType, "BackgroundColorHover")], button["".concat(buttonType, "BackgroundColorHover")], button["".concat(buttonType, "BackgroundColorHover")], button["".concat(buttonType, "BackgroundColorHover")], button["".concat(buttonType, "BackgroundColorHover")], button["".concat(buttonType, "BackgroundColorHover")], button["".concat(buttonType, "BackgroundColorHover")], button["".concat(buttonType, "BackgroundColorHover")], button["".concat(buttonType, "BackgroundColorHover")], button["".concat(buttonType, "BackgroundColor")], disabled && (0, _styledComponents.css)(["cursor:initial;opacity:0.7;pointer-events:none;"]), small && (0, _styledComponents.css)(["", " ", ""], function (_ref6) {
      var theme = _ref6.theme,
        small = _ref6.small;
      return (0, _mediaGenerator.default)(theme, small, "padding: ".concat(button.paddingSmall, ";"));
    }, disabled && (0, _styledComponents.css)(["background:#000;"])));
  }, function (_ref7) {
    var outline = _ref7.outline,
      button = _ref7.theme.button,
      _ref7$buttonType = _ref7.buttonType,
      buttonType = _ref7$buttonType === void 0 ? 'default' : _ref7$buttonType,
      inlineBlock = _ref7.inlineBlock;
    return outline && (0, _styledComponents.css)(["color:", ";box-shadow:inset 0 0 0 ", " ", ";background-color:transparent;display:", ";", ";&:focus{background:", ";}&:hover{background:", " -webkit-radial-gradient( circle,transparent 1%,", " 1% ) center/15000%;background:", " -moz-radial-gradient( circle,transparent 1%,", " 1% ) center/15000%;background:", " -ms-radial-gradient( circle,transparent 1%,", " 1% ) center/15000%;background:", " -o-radial-gradient( circle,transparent 1%,", " 1% ) center/15000%;background:", " radial-gradient( circle,transparent 1%,", " 1% ) center/15000%;}&:active{background-color:", ";background-size:100%;-webkit-transition:background 0s;-moz-transition:background 0s;-ms-transition:background 0s;-o-transition:background 0s;transition:background 0s;}"], button["".concat(buttonType, "BackgroundColor")], button.ghostBorderSize, button["".concat(buttonType, "BackgroundColor")], inlineBlock ? 'inline-block' : 'inline', function (_ref8) {
      var fullWidth = _ref8.fullWidth,
        theme = _ref8.theme;
      return (0, _mediaGenerator.default)(theme, fullWidth, "width: 100%;");
    }, (0, _polished.transparentize)(0.85, button["".concat(buttonType, "BackgroundColor")]), (0, _polished.transparentize)(0.85, button["".concat(buttonType, "BackgroundColor")]), (0, _polished.transparentize)(0.9, button["".concat(buttonType, "BackgroundColor")]), (0, _polished.transparentize)(0.85, button["".concat(buttonType, "BackgroundColor")]), (0, _polished.transparentize)(0.9, button["".concat(buttonType, "BackgroundColor")]), (0, _polished.transparentize)(0.85, button["".concat(buttonType, "BackgroundColor")]), (0, _polished.transparentize)(0.9, button["".concat(buttonType, "BackgroundColor")]), (0, _polished.transparentize)(0.85, button["".concat(buttonType, "BackgroundColor")]), (0, _polished.transparentize)(0.9, button["".concat(buttonType, "BackgroundColor")]), (0, _polished.transparentize)(0.85, button["".concat(buttonType, "BackgroundColor")]), (0, _polished.transparentize)(0.9, button["".concat(buttonType, "BackgroundColor")]), (0, _polished.transparentize)(0.85, button["".concat(buttonType, "BackgroundColor")]));
  }, function (_ref9) {
    var ghost = _ref9.ghost,
      ghostInvert = _ref9.ghostInvert,
      _ref9$theme = _ref9.theme,
      button = _ref9$theme.button,
      colors = _ref9$theme.colors;
    return ghost && (0, _styledComponents.css)(["background-color:transparent;color:", ";border:", " solid ", ";&:focus{background-color:rgba(255,255,255,0.1)};}&:hover{background:rgba(255,255,255,0.1) -webkit-radial-gradient( circle,transparent 1%,rgba(255,255,255,0.1) 1% ) center/15000%;background:rgba(255,255,255,0.1) -moz-radial-gradient( circle,transparent 1%,rgba(255,255,255,0.1) 1% ) center/15000%;background:rgba(255,255,255,0.1) -ms-radial-gradient( circle,transparent 1%,rgba(255,255,255,0.1) 1% ) center/15000%;background:rgba(255,255,255,0.1) -o-radial-gradient( circle,transparent 1%,rgba(255,255,255,0.1) 1% ) center/15000%;background:rgba(255,255,255,0.1) radial-gradient( circle,transparent 1%,rgba(255,255,255,0.1) 1% ) center/15000%;}&:active{background-color:rgba(255,255,255,0.1);background-size:100%;-webkit-transition:background 0s;-moz-transition:background 0s;-ms-transition:background 0s;-o-transition:background 0s;transition:background 0s;}"], ghostInvert ? colors.text01 : button.ghostTextColor, button.ghostBorderSize, ghostInvert ? colors.text01 : button.borderColor);
  }, function (_ref10) {
    var fullWidth = _ref10.fullWidth,
      theme = _ref10.theme;
    return (0, _mediaGenerator.default)(theme, fullWidth, "width: 100%;");
  });
};
exports.buttonStyle = buttonStyle;
var ButtonStyled = _styledComponents.default.button.withConfig({
  displayName: "Buttonstyle__ButtonStyled",
  componentId: "di3ge1-1"
})(["", " position:relative;"], buttonStyle);
exports.ButtonStyled = ButtonStyled;
var Inner = _styledComponents.default.span.withConfig({
  displayName: "Buttonstyle__Inner",
  componentId: "di3ge1-2"
})(["align-items:center;display:inline-flex;justify-content:", ";text-align:center;transition:", ";", ";"], function (_ref11) {
  var icon = _ref11.icon;
  return icon && 'space-between';
}, function (_ref12) {
  var theme = _ref12.theme;
  return loadingTransitionDelayed(theme.animation);
}, function (_ref13) {
  var loading = _ref13.loading,
    theme = _ref13.theme;
  return loading && (0, _styledComponents.css)(["opacity:0;transform:translateY(", ");transition:", ";"], theme.space.xxxs, loadingTransition(theme.animation));
});
exports.Inner = Inner;
var LoadingContainer = _styledComponents.default.span.withConfig({
  displayName: "Buttonstyle__LoadingContainer",
  componentId: "di3ge1-3"
})(["position:absolute;width:100%;height:calc(100% - ", ");top:0;left:0;display:flex;align-items:center;justify-content:center;opacity:0;transform:translateY(", ");transition:", ";", ";"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.space.xxs;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.space.xxs;
}, function (_ref16) {
  var theme = _ref16.theme;
  return loadingTransition(theme.animation);
}, function (_ref17) {
  var loading = _ref17.loading,
    theme = _ref17.theme;
  return loading && (0, _styledComponents.css)(["opacity:1;transform:translateY(", ");transition:", ";"], function (_ref18) {
    var theme = _ref18.theme;
    return theme.space.xxxs;
  }, loadingTransitionDelayed(theme.animation));
});
exports.LoadingContainer = LoadingContainer;